import { ComponentChild, h } from 'preact'
import Panel from '../../control-components/panel'

const IntroductionBar = ({ switcher, dragHandle }: {switcher: ComponentChild, dragHandle: ComponentChild}) => {
  return (
    <Panel
      customClass='homepage-widget'
      title={
        <div className='panel-title-with-switch'>
          <div className='homepage-reorderable-panel-title'>
            { dragHandle }
            <span>Introduction bar</span>
          </div>
          { switcher }
        </div>
      } />
  )
}

export default IntroductionBar
